import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';
import { Warband } from '../../types';
import { warbandService } from '../../services/warbandService';
import { useWarbandStore } from '../../stores/warbandStore';

interface ManageGoldModalProps {
  open: boolean;
  warband: Warband;
  onClose: () => void;
}

export const ManageGoldModal: React.FC<ManageGoldModalProps> = ({ open, warband, onClose }) => {
  const { setWarbands, warbands } = useWarbandStore();
  const [gold, setGold] = React.useState<number>(warband.gold);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (open) {
      setGold(warband.gold);
      setError(null);
    }
  }, [open, warband.gold]);

  const handleSave = async () => {
    if (gold < 0) {
      setError('Gold cannot be negative.');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await warbandService.update(warband.id, { ...warband, gold });
      setWarbands(warbands.map((w) => (w.id === warband.id ? { ...w, gold } : w)));
      onClose();
    } catch {
      setError('Failed to update gold. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Manage Gold</DialogTitle>
      <DialogContent>
        <TextField
          label="Gold (gc)"
          type="number"
          value={gold}
          onChange={(e) => setGold(Math.max(0, parseInt(e.target.value, 10) || 0))}
          fullWidth
          autoFocus
          sx={{ mt: 1 }}
          slotProps={{ htmlInput: { min: 0 } }}
          error={!!error}
          helperText={error ?? undefined}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={loading}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};
